'use strict';

const datalayer = require('./components/datalayer');

document.body.addEventListener('register:success', function (event) {
    if (event.detail.addToNewsletter) {
        datalayer.newsletterSubscriptionTracking('subscribe', event.location);
    }
});
